import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';

import CustomIcon from '../CustomIcon';

const TIMEOUT_MS = 650;

const styles = {
  root: {
    '&:hover': {
      color: props => props.colors.itemMenuHover
    }
  },
  button: {
    height: '28px',
    width: '28px',
    padding: '5px'
  }
};

class CustomDropDown extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.optionHeigth = 44;
    this.marginHeight = 28;
    this.handlerClose = this.handlerClose.bind(this);
    this.handlerClick = this.handlerClick.bind(this);
    this.handlerMouseLeave = this.handlerMouseLeave.bind(this);
    this.handlerMouseEnter = this.handlerMouseEnter.bind(this);
    this.state = {
      open: false,
      click: 0
    };
  }

  static propTypes = {
    iconSize: PropTypes.number,
    optionItems: PropTypes.array,
    id: PropTypes.string,
    isAppOnline: PropTypes.any,
    classes: PropTypes.object,
    lightIconColor: PropTypes.bool,
    dropdownStyle: PropTypes.string
  };

  componentDidMount() {
    const { id } = this.props;
    $(`#dropdown-${id}`).click(ev => {
      this.setState({
        click: ev.pageY
      });
    });
  }

  handlePosition() {
    const { click } = this.state;
    const { id, optionItems } = this.props;
    let componentHeight = optionItems.length * this.optionHeigth + this.marginHeight;
    if (componentHeight > $(window).height() - click) {
      $(`#dropdown-pane-${id}`).css({ top: '', bottom: 25, 'transform-origin': 'right bottom 0' });
    } else {
      $(`#dropdown-pane-${id}`).css({ top: 25, bottom: '', 'transform-origin': 'right top 0' });
    }
  }

  handlerClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.handlerMouseEnter();
    this.handlePosition();
    this.setState({
      open: !this.state.open
    });
  }

  handlerClose() {
    this.setState({
      open: false
    });
  }

  handlerMouseLeave() {
    this.customTimeout = setTimeout(() => {
      this.handlerClose();
    }, TIMEOUT_MS);
  }

  handlerMouseEnter() {
    clearTimeout(this.customTimeout);
  }

  renderOption(index, item) {
    const { classes, isAppOnline } = this.props;

    const itemActionWrapped = e => {
      e.preventDefault();
      e.stopPropagation();
      if (!item.disabled) {
        item.action();
        this.handlerClose();
      }
    };

    let hoverClassName = classes.root;
    if (item.class === 'warning-lowerToDay') {
      hoverClassName = '';
    }
    const disabledClassName = item.disabled ? 'disabled' : '';

    let linkClassName = 'link';
    let linkOnClick = itemActionWrapped.bind(this);
    let itemClassName = `item ${item.class} ${hoverClassName} ${disabledClassName}`;

    if (!isAppOnline && item.disabledOffline) {
      linkClassName = 'data';
      linkOnClick = '';
      itemClassName = 'disabledOffline';
    }

    return (
      <div className={linkClassName} key={index} onClick={linkOnClick}>
        <div className={itemClassName}>
          <span className="icon">{item.icon}</span>
          <span className="text">{item.name} </span>
        </div>
      </div>
    );
  }

  renderOptions() {
    let options = [];
    const { optionItems } = this.props;

    optionItems.forEach((item, index) => {
      options.push(this.renderOption(index, item));
    });

    return options;
  }

  render() {
    const { id, optionItems, iconSize, classes, lightIconColor, dropdownStyle } = this.props;
    const { open } = this.state;
    let showShort = open ? 'show-large' : '';
    let show = open ? 'show' : '';

    if (optionItems.length === 0) return <div />;

    return (
      <div
        className="custom-drop-down-options"
        onBlur={this.handlerClose}
        tabIndex={id}
        id={`dropdown-${id}`}
        onMouseLeave={this.handlerMouseLeave}
      >
        <IconButton aria-label="Delete" className={classes.button} onClick={this.handlerClick}>
          <h5>
            <CustomIcon name="more-vert" color={lightIconColor && 'white'} size={iconSize ? iconSize : 18} />
          </h5>
        </IconButton>
        <div
          className={`custom-drop-down-pane ${dropdownStyle || 'down'} ${showShort}`}
          onClick={this.handlerClose}
          id={`dropdown-pane-${id}`}
        >
          <div className={`custom-drop-down-pane-content ${show}`} onMouseEnter={this.handlerMouseEnter}>
            {this.renderOptions()}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors,
    isAppOnline: state.connection.status.online
  };
}

export default connect(mapStateToProps)(withStyles(styles)(CustomDropDown));
